const translations = {
  title: 'Segmentação',
  'menu.import': 'Importar',
  'menu.importHistory': 'Histórico de importação',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Histórico de exportação',
  'table.name': 'Nome',
  'table.createdAt': 'Data da criação',
  'table.updatedAt': 'Data da atualização'
}

export default translations
